import { AccordionDetails } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';
export const AccordionDetailsWithPadding = styled(AccordionDetails)({
  paddingLeft: 15,
  paddingRight: 15,
  paddingBottom: 15,
});
